/* eslint-disable eqeqeq */
import { formatCanaryConfigValue } from "./format";
import lifetimeTypeEnum from "reactPath/constants/lifetimeTypeEnum";
import app from "reactPath/constants/app";
// import { checkCanaryShowCtrl, getCanarySettingItem } from "./canarySetting";
import osVersion from "./osVersion";
const { protocolVersion = 0, bundleId } = window.PAGE_PARAMS || {};

// 初始化 window.self 对象以兼容浏览器环境
if (typeof window !== 'undefined' && !window.self) {
  window.self = {};
}
if (typeof window !== 'undefined' && !window.self.PAGE_PARAMS) {
  window.self.PAGE_PARAMS = window.PAGE_PARAMS || {};
}

const oneDayTime = 3600 * 24 * 1000;
const Year50 = 50 * 365 * oneDayTime;

export const OsVersion = osVersion;
/**
 * 判断是否需要显示 bluramsGuard 品牌内容
 */
export const isBluramsGuard =
  app.isBluramsApp(bundleId) && protocolVersion > 26;

/**
 * check终生套餐状态
 * @param {*} service
 * @returns lifetimeTypeEnum
 */
export function checkLifetimeService(service) {
  let {
    iconTags = "",
    serviceFrequency,
    serviceTime,
    endTime,
    activeTime,
    serviceEndTime,
    isAutorenew,
  } = service || {};
  activeTime = activeTime || Date.now();

  if (!iconTags || iconTags.indexOf("lifetime") < 0)
    return lifetimeTypeEnum.FALSE;
  if (serviceTime === "2" && serviceFrequency !== "YEAR")
    return lifetimeTypeEnum.FAKE;
  if (!serviceEndTime && !endTime) return lifetimeTypeEnum.TRUE;
  if (serviceEndTime && serviceEndTime - activeTime > Year50)
    return lifetimeTypeEnum.TRUE;
  if (endTime && endTime - activeTime > Year50) return lifetimeTypeEnum.TRUE;
  return isAutorenew == 1
    ? lifetimeTypeEnum.TRUE_CIRCLING
    : lifetimeTypeEnum.TRUE_CIRCLING_CANCEL;
}
/**
 * 是否终生套餐
 */
export function isLifetimeService(service) {
  const type = checkLifetimeService(service);
  //console.info(type, service);
  return type !== lifetimeTypeEnum.FALSE;
}
/**
 * 是否有效终生套餐
 */
export function isLifetimeValidService(service) {
  const type = checkLifetimeService(service);
  //console.info(type, service);
  return [
    lifetimeTypeEnum.FAKE,
    lifetimeTypeEnum.TRUE,
    lifetimeTypeEnum.TRUE_CIRCLING,
  ].includes(type);
}
/**
 * 是否是pro设备
 * @param {*} modelId
 * @returns
 */
export function isProDeviceModel(cameraModelId = "") {
  if (!cameraModelId) return false;
  let { freeFacePackageModelIds = [] } = window.self.SYSTEM_CONFIG || {};
  let canaryConfigProModelIds =
    formatCanaryConfigValue("blurams_pro_model_id") || [];
  let proDeviceModelIds = (window.self.SYSTEM_CONFIG.freeFacePackageModelIds =
    Array.from(
      new Set([...freeFacePackageModelIds, ...canaryConfigProModelIds])
    ));
  return proDeviceModelIds.some(
    (configModelId) =>
      configModelId.toUpperCase().indexOf(cameraModelId.toUpperCase()) > -1
  );
}

/**
 * 针对设备型号配置能力集黑名称,限制设备支持能力集,在UI上也不显示.
 * @param {*} cameraModelId
 * @param {*} featureKey
 * @returns
 */
export function inFeatureBlackList(cameraModelId = "", featureKey) {
  if (!cameraModelId || !featureKey) return false;
  let { canaryGlobalAttrs = {} } = window.self.SYSTEM_CONFIG || {};
  let { feature_black_list: featureBlackList } = canaryGlobalAttrs;
  if (featureBlackList) {
    try {
      featureBlackList = JSON.parse(featureBlackList);
      return featureBlackList[cameraModelId]?.includes(featureKey) || false;
    } catch (e) {
      console.error("bi global config feature_black_list: " + featureBlackList);
    }
  }
  return false;
}
/**
 * BI配置设备是否支持AI能力
 * @param {*} cameraModelId
 * @returns
 */
// export function supportAILabFeature(canarySetting, featureEnum) {
//   if (!canarySetting) return false;
//   const { status } = getCanarySettingItem(
//     featureEnum,
//     { status: 0 },
//     canarySetting
//   );
//   return status === 1; // || checkCanaryShowCtrl(featureEnum, canarySetting);
// }
/**
 * 判断是否支持group组的showBitNum位是否显示
 * @param {*} cameraModelId
 * @returns
 */
// export function supportGroupBitNum(
//   canarySetting,
//   featureEnum,
//   { group = 1, showBitNum = 0 }
// ) {
//   if (!canarySetting) return false;
//   const { desc } = getCanarySettingItem(
//     featureEnum,
//     { status: 0 },
//     canarySetting
//   );
//   return (
//     ((desc || [])[group - 1] & Math.pow(2, showBitNum)) >> showBitNum === 1
//   );
// }
/**
 * 当前主题是否是暗黑模式
 * @returns
 */
export function isDarkBlackPageTheme() {
  let webPageTheme =
    (window.self?.PAGE_PARAMS?.webTheme) ||
    localStorage.getItem("bluramsWebAppTheme") ||
    "default";
  return webPageTheme === "black";
}

//IOS上使用ThemeType.afloat需要protocol >= 16 (历史版本存在问题)
export const canUseAfloatTheme = OsVersion.isAndroid || protocolVersion >= 16;

/**
 * 门铃设备
 * @param {*} modelId
 * @returns
 */
export function isDoorbellDevice(modelId) {
  modelId = modelId || "";
  if (checkModelTypeCharByServerModelId(modelId) === "D") return true;
  return ["D10C", "D10S"].some((prefix) => modelId.startsWith(prefix));
}

/**
 * 低功耗IPC
 * @param {*} modelId
 * @returns
 */
export function isLPCDevice(modelId) {
  modelId = modelId || "";
  if (checkModelTypeCharByServerModelId(modelId) === "N") return true;
  return ["A11C"].some((prefix) => modelId.startsWith(prefix));
}

/**
 * 4G设备
 * @param {*} modelId
 * @returns
 */
export function is4GDevice(modelId) {
  modelId = modelId || "";
  return checkModelTypeCharByServerModelId(modelId) == "F";
}

/**
 *
 * @param {*} serverModelId
 * @returns
 */
export function checkModelTypeCharByServerModelId(serverModelId) {
  if (!serverModelId) {
    return "";
  }
  if (serverModelId.length >= 7) {
    const a1 = serverModelId.charAt(0);
    const a2 = serverModelId.charAt(1);
    const a3 = serverModelId.charAt(2);
    const a4 = serverModelId.charAt(3);
    if (
      a1 == "V" &&
      a4 == "_" &&
      a2 >= "0" &&
      a2 <= "9" &&
      ((a3 >= "A" && a3 <= "Z") || (a3 >= "a" && a3 <= "z"))
    ) {
      return a3;
    }
  }
  return "";
}
/**
 *
 * @param {*} deviceInfo {modelId, cameraModelId}
 * @param {*} serviceInfo {detailTypes,serverModelIdTypes,filterType}
 */
export function checkDeviceCanBindService(
  { modelId, cameraModelId },
  { detailTypes, serverModelIdTypes, filterType = 1 }
) {
  const serverModelIdChar = checkModelTypeCharByServerModelId(modelId);
  /**
   * 0 就是都可绑定
   * 1 为include模式
   * 2 为exclude模式
   */
  if (filterType == "0") return true;
  else if (filterType == "1") {
    if (!detailTypes?.length) return true;
    if (detailTypes?.includes(cameraModelId) || detailTypes.includes(modelId))
      return true;
    if (!serverModelIdTypes?.length) return true;
    if (serverModelIdTypes?.includes(serverModelIdChar)) return true;
    return false;
  } else if (filterType == "2") {
    if (!detailTypes && !serverModelIdTypes) return true;
    if (detailTypes?.includes(cameraModelId) || detailTypes.includes(modelId))
      return false;
    if (serverModelIdTypes?.includes(serverModelIdChar)) return false;
    return true;
  }
}
